<!--http://getbootstrap.com/css/#forms-controls-->

<select class="form-control" (change)="selectItem($event)">
  <option disabled>Choose {{parent.view.title.toLowerCase()}}</option>
  <option *ngFor="let vw of itemsView" (click)="selectItem($event)">
    <standard-dropdown-item [view]="vw" (click)="selectItem($event)"></standard-dropdown-item>
  </option>
</select>